import { Alert, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { loginAdminSchema } from "../../schema/adminSchema";
import { getAdminByEmail } from "../../api/admins";
import { mockAdminLoginFields } from "../../data/mockAdminData";
import {
  getLocalStorageValue,
  setLocalStorageValue,
} from "../../utils/localStorage";
import AuthLayout from "../global/AuthLayout";
import FormFooter from "../shared/FormFooter";
import AuthForm from "../shared/AuthForm";

const initialValues = {
  email: "",
  password: "",
};

const AdminLogin = () => {
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const result = getLocalStorageValue("admin");
    if (result) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleFormSubmit = useCallback(
    async (values) => {
      try {
        const adminData = await getAdminByEmail(values.email);
        setLocalStorageValue("admin", adminData);
        navigate("/dashboard");
      } catch (error) {
        setErrorMessage(error.response.data.msg);
        setIsError(true);
        setTimeout(() => {
          setIsError(false);
        }, 3000);
      }
    },
    [navigate]
  );

  return (
    <AuthLayout title="Login Admin">
      {isError && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {errorMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={loginAdminSchema}
        fields={mockAdminLoginFields}
        onSubmit={handleFormSubmit}
      >
        <FormFooter
          text="If you don't have any account"
          link="adminRegister"
          linkText="register"
          buttonText="Login Admin"
        />
      </AuthForm>
    </AuthLayout>
  );
};

export default AdminLogin;
